import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Affectation } from '../model/affectation.model';
import { Building } from '../model/building.model';
import { UpdateTypologyDto } from '../model/typology.dto';
import { ColorTypology } from '../model/typology.model';
import { ModalHeaderComponent } from '../../shared/modal/modal-header/modal-header.component';
import { TypologyEditorComponent } from '../typology-editor/typology-editor.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-typology',
  templateUrl: 'typology.component.html',
  styleUrls: ['typology.component.scss'],
  imports: [ModalHeaderComponent, TypologyEditorComponent, TranslocoPipe],
})
export class TypologyComponent {
  @Input() building: Building;
  @Input() affectations: Affectation[];
  @Input() authorizedForBuilding: boolean;
  @Input() ecabOrAbove: boolean;

  @Output() typologyChanged = new EventEmitter<UpdateTypologyDto>();
  @Output() closeModal = new EventEmitter();

  save(color: ColorTypology, affectationKeys: string[], justification: string) {
    this.typologyChanged.emit({
      color,
      affectationKeys,
      justification,
    });
  }
}
